<div *ngIf="!isTaskEditMode" class="task-detail-header">
    <gsp-button [type]="ButtonType.Icon" [iconClass]="'icon-arrow-back-black i24'" (action)="back()"></gsp-button>
    <h2 class="title" *ngIf="isAddUserMode">{{ 'TC.AddUsers' | translate }}</h2>
    <ng-container *ngIf="!isAddUserMode">
        <h2 class="title">{{ 'TC.Common.AssignedUsers' | translate }}</h2>
        <div class="task-panel-menu-bar">
            <gsp-button
                *ngIf="!loading && modifyPermission"
                [type]="ButtonType.Icon"
                [iconClass]="'icon_line_plus i24'"
                title="{{ 'TC.AddUsers' | translate }}"
                (action)="isAddUserMode = true"
            ></gsp-button>
        </div>
    </ng-container>
</div>
<loading *ngIf="loading" class="loading-align-center"></loading>
<ng-container *ngIf="!loading && (!isAddUserMode || isTaskEditMode)">
    <user-filter
        *ngIf="isTaskEditMode"
        class="tag-input-alternative"
        [inputClass]="'tag-input-form'"
        [(selectedUsers)]="assignedUsers"
        (selectedUsersChange)="createAssigneeToTaskFeaturesMap()"
        [hideSelectedUserChips]="true"
        [allUsers]="currentProjectAssignees"
        [placeholder]="'TC.Common.SearchByTypingName' | translate"
    ></user-filter>
    <custom-scroll class="assigned-users-scroll">
        <ul class="assigned-users-list" [ngClass]="{ 'edit-mode-layout': isTaskEditMode }">
            <li *ngFor="let user of assignedUsers" class="assigned-users-item">
                <div class="user-profile">
                    <div class="user-container">
                        <i
                            [ngClass]="
                                user.isTodoCompleted ? 'icon-tick-in-circle-green i24' : 'icon_solid_user_24 i24'
                            "
                        ></i>
                        <div class="text-overflow">{{ user.name }}</div>
                    </div>
                    <gsp-button
                        class="remove-user-button"
                        *ngIf="isTaskEditMode && !user.isTodoCompleted"
                        [type]="ButtonType.Icon"
                        [iconClass]="'icon_line_close_24 i24'"
                        (action)="removeUserFromSelection(user.id)"
                    ></gsp-button>
                </div>
                <div class="form-collection-details">
                    <span
                        >{{ 'TC.TodosTasks.FormsUpdated' | translate }}
                        <span class="form-collection-details-value">
                            <i *ngIf="isTaskEditMode" class="icon_solid_clipboard_24 mixin-icon-24"></i
                            >{{ assigneeTaskFeaturesMap[user.id].updatedFeatures.length }}</span
                        >
                    </span>
                    <span
                        >{{ 'TC.Common.NewFormsCollected' | translate }}
                        <span class="form-collection-details-value">
                            <i *ngIf="isTaskEditMode" class="icon_solid_clipboard_24 mixin-icon-24"></i
                            >{{ assigneeTaskFeaturesMap[user.id].newFeatures.length }}</span
                        >
                    </span>
                    <gsp-button
                        *ngIf="!isTaskEditMode"
                        [iconClass]="'icon_solid_cursor_32 i16'"
                        class="select-all-forms-button"
                        text="{{ 'TC.Common.SelectAllForms' | translate }}"
                        [type]="ButtonType.Transparent"
                        (action)="selectAssigneeForms(user.id)"
                        [disabled]="!hasUpdatedOrNewForms(user.id)"
                    ></gsp-button>
                </div>
            </li>
        </ul>
    </custom-scroll>
</ng-container>

<div *ngIf="isAddUserMode && !loading" class="add-assigned-users">
    <user-filter
        class="tag-input-alternative"
        [inputClass]="'tag-input-form'"
        [(selectedUsers)]="newAssignedUsers"
        [hideSelectedUserChips]="true"
        [allUsers]="getUsersNotAssigned()"
        [placeholder]="'TC.Common.SearchByTypingName' | translate"
    ></user-filter>
    <custom-scroll class="assigned-users-scroll">
        <ul class="assigned-users-list">
            <li *ngFor="let user of newAssignedUsers" class="assigned-users-item">
                <div class="user-profile">
                    <div class="user-container">
                        <i class="icon_solid_user_24 i24"></i>
                        <div class="text-overflow">{{ user.name }}</div>
                    </div>
                    <gsp-button
                        class="remove-user-button"
                        [type]="ButtonType.Icon"
                        [iconClass]="'icon_line_close_24 i24'"
                        (action)="removeUserFromSelection(user.id)"
                    ></gsp-button>
                </div>
            </li>
        </ul>
    </custom-scroll>
</div>
<footer *ngIf="isAddUserMode && !loading">
    <gsp-button
        [disabled]="!newAssignedUsers.length"
        [type]="ButtonType.Primary"
        (action)="saveAssignedUsers()"
        text="{{ 'TC.Common.Done' | translate }}"
        id="save-add-users"
    ></gsp-button>
    <gsp-button
        [type]="ButtonType.Transparent"
        (action)="back()"
        text="{{ 'cancel' | translate }}"
        id="cancel-add-users"
    ></gsp-button>
</footer>
